import { render, staticRenderFns } from "./AboutImageBannerBlock.vue?vue&type=template&id=e82d53ca&scoped=true&lang=pug&"
import script from "./AboutImageBannerBlock.vue?vue&type=script&lang=js&"
export * from "./AboutImageBannerBlock.vue?vue&type=script&lang=js&"
import style0 from "./AboutImageBannerBlock.vue?vue&type=style&index=0&id=e82d53ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82d53ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e82d53ca')) {
      api.createRecord('e82d53ca', component.options)
    } else {
      api.reload('e82d53ca', component.options)
    }
    module.hot.accept("./AboutImageBannerBlock.vue?vue&type=template&id=e82d53ca&scoped=true&lang=pug&", function () {
      api.rerender('e82d53ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/AboutImageBannerBlock.vue"
export default component.exports